module.exports = __webpack_public_path__ + "static/HomeCoachUpdate-9f4c5b25e5c1258c719f831592ab3036.jpg";